module.exports = __webpack_public_path__ + "img/148.2249d568.jpg";